// The design upload behaviour - file input plus drag-and-drop - shared by
// give_checkout_controller.js, give_redemption_controller.js and give_design_controller.js.
const FILE_INPUTS = ["#new-design", "#new-logo"];
let alreadyInitializedDragNDrop = false;

const initFileUploader = () => {
  FILE_INPUTS.forEach((fileInput) => {
    document.body.addEventListener("change", (e) => {
      if (!e.target.matches(fileInput)) { return; }

      const form = e.target.closest("form");
      const url = form.action;
      const file = e.target.files[0];
      const formData = new FormData();
      const useSameDesignCheckbox = form.querySelector(".use-as-email-design input[type='checkbox']");

      if (fileInput === "#new-design") {
        formData.append("design[upload]", file);
      } else {
        formData.append("logo[image]", file);
      }

      if (useSameDesignCheckbox && useSameDesignCheckbox.checked) {
        formData.append("design[use_as_email_design]", "1");
      }

      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        contentType: false,
        processData: false,
        success: () => {},
        beforeSend: () => {
          document.querySelector(".drag-n-drop").classList.toggle("hide");
          document.querySelector(".upload-progress").classList.toggle("hide");
        },
        xhr: () => {
          const xhr = new window.XMLHttpRequest();

          xhr.upload.addEventListener("progress", (evt) => {
            if (evt.lengthComputable) {
              let percentComplete = evt.loaded / evt.total;
              percentComplete = parseInt(percentComplete * 100);

              if (percentComplete === 100) {
                document.querySelector(".upload-progress p").textContent = "Processing... Please wait, page will refresh when complete.";
              }

              document.querySelector(".upload-progress .progress-bar").style.width = percentComplete + "%";
            }
          }, false);

          return xhr;
        }
      });
    });
  });
};

const resetDragNDropEvents = (dropContainer) => {
  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    dropContainer.addEventListener(eventName, (e) => {
      e.preventDefault();
      e.stopPropagation();
    }, false);
  });
};

const initializeDragNDrop = () => {
  if (alreadyInitializedDragNDrop) { return true; }

  const dropContainer = document.querySelector(".drag-n-drop-container");

  FILE_INPUTS.forEach((selector) => {
    const fileInput = document.querySelector(selector);

    if (!fileInput) { return false; }

    resetDragNDropEvents(dropContainer);

    ["dragenter", "dragover"].forEach((eventName) => {
      dropContainer.addEventListener(eventName, () => {
        dropContainer.classList.add("active");
      }, false);
    });

    ["dragleave", "drop"].forEach((eventName) => {
      dropContainer.addEventListener(eventName, () => {
        dropContainer.classList.remove("active");
      }, false);
    });

    dropContainer.addEventListener("drop", (e) => {
      const dataTransfer = e.dataTransfer;
      const files = dataTransfer.files;

      if (files) {
        fileInput.files = dataTransfer.files;
        fileInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }, false);
  });

  alreadyInitializedDragNDrop = true;
};

export default class {
  static initialize() {
    initFileUploader();
  }

  static showNewUpload(isMobileMenuOpen) {
    if (isMobileMenuOpen) {
      document.querySelector(".btn-upload-file").click();
    } else {
      initializeDragNDrop();
      document.querySelector(".design-tray").classList.add("hide");
      document.querySelector(".btn-start-upload").classList.add("hide");
      document.querySelector(".new-design-uploader").classList.remove("hide");
    }
  }

  static hideNewUpload() {
    document.querySelector(".design-tray").classList.remove("hide");
    document.querySelector(".btn-start-upload").classList.remove("hide");
    document.querySelector(".new-design-uploader").classList.add("hide");
  }
}
